module.exports = __webpack_public_path__ + "static/media/project10.ce784a12.jpg";